export default class VampiVoiceClient {
	constructor(baseUrl, key) {
		if(!baseUrl) throw new Error('No API URL specified');
		if(!key) throw new Error('No API key specified');
		this.baseUrl = baseUrl;
		this.apiKey = key;
	}

	getSpeechUrl(text, provider, voice, rate, pitch, style, role) {
		return `${this.baseUrl}/api/synthesizeSpeech?${new URLSearchParams({ provider, voice, rate, pitch, text, style, role })}`;
	}

	synthesizeRequest(text, provider, voice, rate, pitch, style, role, signal) {
		const url = this.getSpeechUrl(text, provider, voice, rate||0, pitch||0, style||'default', role||'default');
		return fetch(url, {
			withCredentials: true,
			credentials: 'include',
			signal,
			headers: {
				Authorization: this.apiKey,
			},
		});
	}

	synthesizeSpeech(text, provider, voice, rate, pitch, style, role, signal) {
		return this.synthesizeRequest(text, provider, voice, rate, pitch, style, role, signal).then(r => r.arrayBuffer());
	}
}
